import React, { useState } from "react";
import { CodedProperty, ValidationResult } from "sprint-common-web";

import { UpdateFileRecordSubtitleRequest } from "../../../../../../../../common/api/master-api/file-records/update/subtitle/UpdateFileRecordSubtitleRequest";
import { useFileRecordApi } from "../../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { ensureSubtitleFileRecordDetails } from "../../../../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../../../../hooks/useFileRecordDetailsState";
import { DynamicSubtitleForm } from "./EditDynamicSubtitleForm";

export interface EditDynamicSubtitleAsideContentProps {
    fileRecordId: string;
    onCancel(): void;
    onSubmit(): void;
}

export const EditDynamicSubtitleAsideContent = (props: EditDynamicSubtitleAsideContentProps): JSX.Element => {
    const { fileRecordId, onSubmit, onCancel } = props;

    const { fileRecordDetails, setFileRecordDetails } = useFileRecordDetailsState();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [validationResult, setValidationResult] = useState<ValidationResult>();
    const { updateFileRecordSubtitle } = useFileRecordApi();

    const updateSubtilte = (subtitle: CodedProperty) => {
        ensureSubtitleFileRecordDetails(fileRecordDetails);

        const request: UpdateFileRecordSubtitleRequest = {
            id: fileRecordId,
            subtitle: { language: subtitle }
        };

        setIsLoading(true);

        updateFileRecordSubtitle(request)
            .then(() => {
                setFileRecordDetails({
                    ...fileRecordDetails,
                    subtitle
                });

                onSubmit();
            })
            .catch((res) => {
                setValidationResult(res);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <DynamicSubtitleForm
            isLoading={isLoading}
            onCancel={onCancel}
            onSubmit={updateSubtilte}
            validationResult={validationResult}
        />
    );
};
